import { render, staticRenderFns } from "./ServiceAskingPage.vue?vue&type=template&id=4bba3557&scoped=true&"
import script from "./ServiceAskingPage.vue?vue&type=script&lang=js&"
export * from "./ServiceAskingPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAskingPage.vue?vue&type=style&index=0&id=4bba3557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba3557",
  null
  
)

export default component.exports